import { render, staticRenderFns } from "./MonitorarVirtualBackup.vue?vue&type=template&id=62852b26&scoped=true"
import script from "./MonitorarVirtualBackup.vue?vue&type=script&lang=js"
export * from "./MonitorarVirtualBackup.vue?vue&type=script&lang=js"
import style0 from "./MonitorarVirtualBackup.vue?vue&type=style&index=0&id=62852b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62852b26",
  null
  
)

export default component.exports